export default __webpack_public_path__ + "static/media/cole-farm-store.4e8f4273.jpg";